export const ASSETS = {
  "backgroundEntities": {
    "brittleRefrigerator": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/entities/brittle_refrigerator.png",
      "height": 250,
      "transparent": true,
      "width": 150
    },
    "drippingFaucet": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/entities/dripping_faucet.png",
      "height": 80,
      "transparent": true,
      "width": 60
    },
    "faintSilhouette": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/entities/faint_silhouette.png",
      "height": 300,
      "transparent": true,
      "width": 100
    },
    "movingShadows": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/entities/moving_shadows.png",
      "height": 200,
      "transparent": true,
      "width": 400
    },
    "portraitEyes": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/entities/portrait_eyes.png",
      "height": 60,
      "transparent": true,
      "width": 100
    },
    "shadowyFace": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/entities/shadowy_face.png",
      "height": 200,
      "transparent": true,
      "width": 200
    },
    "watchingEyes": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/entities/watching_eyes.png",
      "height": 40,
      "transparent": true,
      "width": 80
    }
  },
  "backgrounds": {
    "basementPortraits": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/backgrounds/basement_portraits.png",
      "height": 800,
      "transparent": false,
      "width": 1200
    },
    "corridor": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/backgrounds/corridor.png",
      "height": 800,
      "transparent": false,
      "width": 1200
    },
    "dampCorridors": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/backgrounds/damp_corridors.png",
      "height": 800,
      "transparent": false,
      "width": 1200
    },
    "enormousMoonRoom": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/backgrounds/enormous_moon_room.png",
      "height": 800,
      "transparent": false,
      "width": 1200
    },
    "houseRoom": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/backgrounds/house_room.png",
      "height": 800,
      "transparent": false,
      "width": 1200
    },
    "introRoom": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/backgrounds/menu_hallway.png",
      "height": 300,
      "width": 300
    },
    "menuHallway": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/backgrounds/menu_hallway.png",
      "height": 1080,
      "transparent": false,
      "width": 1920
    },
    "mirrorHallway": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/backgrounds/mirror_hallway.png",
      "height": 800,
      "transparent": false,
      "width": 1200
    },
    "realityCollapse": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4a7ee2de328f4b258c7818c5946688fd/a6429b3ca8a74a4787ed7f76b5986d6b/preview/assets/backgrounds/realityCollapse.png",
      "height": 800,
      "transparent": false,
      "width": 1200
    },
    "realityShiftsRoom": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/backgrounds/reality_shifts_room.png",
      "height": 800,
      "transparent": false,
      "width": 1200
    },
    "redSkyRoom": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/backgrounds/red_sky_room.png",
      "height": 800,
      "transparent": false,
      "width": 1200
    },
    "shiftingHallways": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/backgrounds/shifting_hallways.png",
      "height": 800,
      "transparent": false,
      "width": 1200
    }
  },
  "effects": {
    "breath": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/0a8a9d967af44a13b5c19fe25f741775/preview/assets/effects/breath.png",
      "height": 200,
      "transparent": true,
      "width": 300
    },
    "doorFog": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/f74ce49b3b8e45c69bfc7631c9fa50d0/main/preview/assets/other/creepy_fog.png",
      "height": 300,
      "width": 300
    }
  },
  "entities": {
    "reflection": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/fd76f99d44da4f5d8f5845b99636b0f1/main/preview/assets/characters/faded_reflection.png",
      "height": 300,
      "width": 300
    },
    "shadowCompanion": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/entities/shadow_companion.png",
      "height": 300,
      "transparent": true,
      "width": 180
    },
    "theGuest": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/entities/the_guest.png",
      "height": 360,
      "transparent": true,
      "width": 220
    }
  },
  "icons": {
    "darkness": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/icons/darkness.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "door": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/icons/door_icon.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "foundation": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/icons/foundation.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "house": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/icons/house.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "memory": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/icons/memory.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "mirrors": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/icons/mirrors.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "night": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/icons/night.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "oldphotograph": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/0a8a9d967af44a13b5c19fe25f741775/preview/assets/icons/old_photograph.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "portraits": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/icons/portraits.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "silence": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/icons/silence.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "thirst": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/icons/thirst.png",
      "height": 64,
      "transparent": true,
      "width": 64
    }
  },
  "intro": {
    "candleLit": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/d0b2c93e5ca74c24af2e4191d64b83dd/preview/assets/intro/candle_lit.png",
      "height": 96,
      "transparent": true,
      "width": 64
    },
    "candleUnlit": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/d0b2c93e5ca74c24af2e4191d64b83dd/preview/assets/intro/candle_unlit.png",
      "height": 96,
      "transparent": true,
      "width": 64
    }
  },
  "introEntities": {
    "oldPhotograph": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/0a8a9d967af44a13b5c19fe25f741775/preview/assets/introEntities/old_photograph.png",
      "height": 120,
      "transparent": true,
      "width": 100
    }
  },
  "intrusions": {
    "eyes": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/intrusions/eyes.png",
      "height": 300,
      "width": 300
    },
    "face": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/intrusions/face.png",
      "height": 300,
      "width": 300
    },
    "shadow": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/intrusions/shadow.png",
      "height": 300,
      "transparent": true,
      "width": 150
    }
  },
  "jumpscares": {
    "creature": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/jumpscares/creature.png",
      "height": 1080,
      "transparent": true,
      "width": 1920
    },
    "face": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/jumpscares/face.png",
      "height": 1080,
      "transparent": true,
      "width": 1920
    }
  },
  "logos": {
    "titleBleeding": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/9b6fd544d3e345a588609ba7ce5c772b/main/preview/assets/other/underneath_the_house_logo.png",
      "height": 300,
      "width": 300
    },
    "titleCracked": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/5deda4d8bbc74e9e8ba1dca1b72427dc/main/preview/assets/other/underneath_the_house_logo.png",
      "height": 300,
      "width": 300
    },
    "titleDistorted": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/71417ec3d38043408dca86ec55ac3bd6/main/preview/assets/other/underneath_the_house_logo.png",
      "height": 300,
      "width": 300
    },
    "titleFlicker": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/41a4c605573642dc9de52e2285681c3c/main/preview/assets/other/underneath_the_house_logo.png",
      "height": 300,
      "width": 300
    },
    "titleInverted": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/2e69cb9e2004409e9eee3e8fb66ebcb2/main/preview/assets/other/underneath_the_house_logo.png",
      "height": 300,
      "width": 300
    },
    "titleMissingLetter": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/d2e89341d61444f5aa1eac5a653e086e/main/preview/assets/other/underneath_the_house_logo.png",
      "height": 300,
      "width": 300
    },
    "titleNormal": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/0233b188eddc4987884d18f3da877f7c/main/preview/assets/other/underneath_the_house_logo.png",
      "height": 300,
      "width": 300
    },
    "titleShadow": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/028cd5db9c8345acb2e926b2095512d7/main/preview/assets/other/underneath_the_house_logo_icon.png",
      "height": 300,
      "width": 300
    }
  },
  "music": {
    "ambientBasement": {
      "path": "https://ucarecdn.com/1230c1bb-a68b-42ed-8d05-ab250038df8e/music-box-horror-369338.mp3",
      "height": 300,
      "width": 300
    },
    "ambientTense": {
      "path": "https://ucarecdn.com/7b84955e-995a-45f6-aeb1-48c0ff45f1d8/635664__laurenponder__the-orb.wav",
      "height": 300,
      "width": 300
    },
    "endTheme": {
      "path": "https://ucarecdn.com/a4344f2f-a5cb-49b2-a7b8-c6e39137547e/ending music.mp3",
      "height": 300,
      "width": 300
    }
  },
  "procedural": {
    "overlay_blood": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/overlay_blood.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "overlay_cracks": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/overlay_cracks.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "overlay_fog": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/overlay_fog.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "overlay_stains": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/overlay_stains.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "overlay_vignette": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/overlay_vignette.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "symbol_eye": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/symbol_eye.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "symbol_face": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/symbol_face.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "symbol_hand": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/symbol_hand.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "symbol_mouth": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/symbol_mouth.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "symbol_spiral": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/symbol_spiral.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "texture_concrete": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/texture_concrete.png",
      "height": 64,
      "transparent": false,
      "width": 64
    },
    "texture_fabric": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/texture_fabric.png",
      "height": 64,
      "transparent": false,
      "width": 64
    },
    "texture_static": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/texture_static.png",
      "height": 64,
      "transparent": false,
      "width": 64
    },
    "texture_wood": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/563d5e285a9f4d62944b60c24f3d20a8/preview/assets/procedural/texture_wood.png",
      "height": 64,
      "transparent": false,
      "width": 64
    }
  },
  "sfx": {
    "candleLight": {
      "path": "https://ucarecdn.com/e155435d-b126-4395-9156-7c032002b891/514259__jtn191__matchstrike1.wav",
      "height": 300,
      "width": 300
    },
    "combineFail": {
      "path": "https://ucarecdn.com/84b1d106-a83b-43cd-9fd0-f1304d376d28/483598__raclure__wrong.mp3",
      "height": 300,
      "width": 300
    },
    "combineSuccess": {
      "path": "https://ucarecdn.com/11e6a9a0-60bb-423b-bbbb-252e0e0f0ebe/476178__unadamlar__correct-choice.wav",
      "height": 300,
      "width": 300
    },
    "doorAppear": {
      "path": "https://ucarecdn.com/22b4ecfa-1829-4ba1-a3b3-7d34cefaef4c/560743__mariecaron__slamming-door.mp3",
      "height": 300,
      "width": 300
    },
    "doorCreak": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/sfx/door_creak.ogg"
    },
    "driftDecrease": {
      "path": "https://ucarecdn.com/2644af9d-cd49-4524-8044-5d84218e4af5/342684__michael_kur95__decrease-02.wav",
      "height": 300,
      "width": 300
    },
    "driftIncrease": {
      "path": "https://ucarecdn.com/4bcf3279-4e15-426d-82f8-9ce1c0b46cc3/405551__raclure__suspens-sound-effect.wav",
      "height": 300,
      "width": 300
    },
    "elementAppear": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/sfx/element_appear.ogg"
    },
    "flicker": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/sfx/flicker.ogg"
    },
    "heartbeat": {
      "path": "https://ucarecdn.com/70aea4b1-05e0-4f8e-869e-b1187995b271/92036__urupin__heartbeat.mp3",
      "height": 300,
      "width": 300
    },
    "inactivityPulse": {
      "path": "https://ucarecdn.com/d2335a09-e0fd-4695-9453-1acdc5119753/405551__raclure__suspens-sound-effect.wav",
      "height": 300,
      "width": 300
    },
    "introAmbient": {
      "path": "https://ucarecdn.com/cd1a149f-e335-450c-abfe-5bd3931b9ca3/697057__inmotionaudio__dsgnbram_bramdistorted01_inmotionaudio_freesamplesunday.wav",
      "height": 300,
      "width": 300
    },
    "jumpscare1": {
      "path": "https://ucarecdn.com/749779bd-7d4a-4e72-aa6e-0343c71e8afa/472371__joseagudelo__06_susto_de_amy.wav",
      "height": 300,
      "width": 300
    },
    "jumpscare2": {
      "path": "https://ucarecdn.com/63535645-c178-4e23-9968-51d7ed616b5a/770549__technobyte360__revtone.wav",
      "height": 300,
      "width": 300
    },
    "menuAmbient": {
      "path": "https://ucarecdn.com/8dca35bd-493e-487a-afc0-9e970b8fb0bd/697057__inmotionaudio__dsgnbram_bramdistorted01_inmotionaudio_freesamplesunday.wav",
      "height": 300,
      "width": 300
    },
    "menuFootsteps": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/sfx/menu_footsteps.ogg"
    },
    "menuKnock": {
      "path": "https://ucarecdn.com/a5873e4d-1825-4ab7-adce-da8d008a8688/648875__longor__plock-high.ogg",
      "height": 300,
      "width": 300
    },
    "mirrorBreak": {
      "path": "https://ucarecdn.com/e4b7b79b-4400-4de0-b248-f187b164122c/368350__johandeecke__glass-hit-23.wav",
      "height": 300,
      "width": 300
    },
    "realityShift": {
      "path": "https://ucarecdn.com/09eff085-0259-448a-b5e4-e1c8f60f975c/46088__thedialogueproject__reverse-push-it-test.aiff",
      "height": 300,
      "width": 300
    },
    "whisper": {
      "path": "https://ucarecdn.com/48dfc5a9-fe18-4392-866a-5431748db71e/102308__thatjeffcarter__listen-with-reverb-delay.wav",
      "height": 300,
      "width": 300
    }
  },
  "ui": {
    "arrowLeft": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/ui/arrow_left.svg",
      "height": 24,
      "transparent": true,
      "width": 24
    },
    "arrowRight": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/ui/arrow_right.svg",
      "height": 24,
      "transparent": true,
      "width": 24
    },
    "card": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/ui/card.png",
      "height": 48,
      "transparent": true,
      "width": 48
    },
    "creepyDoorClosed": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/020bbed7cda945e9a508eec9e7c638b3/main/preview/assets/other/creepy_gray_door.png",
      "height": 300,
      "width": 300
    },
    "creepyDoorOpen": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/2499e4f60f114bc49dcb6e58c8033be2/preview/assets/ui/creepyDoorOpen.png",
      "height": 540,
      "transparent": true,
      "width": 300
    },
    "door": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/5eacefeb38a141898b11ba04a2d88ac6/preview/assets/ui/menu_door.png",
      "height": 300,
      "width": 300
    },
    "doorAjar": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/58295cccf1aa40bebe69b60ded59675a/d71264a9aaa34714b3cc3df27beceb98/preview/assets/ui/door_ajar.png",
      "height": 180,
      "transparent": true,
      "width": 120
    },
    "historyJournal": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/ui/history_journal.png",
      "height": 300,
      "width": 300
    },
    "menuDoor": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/ui/menu_door.png",
      "height": 400,
      "transparent": true,
      "width": 200
    },
    "mysteriousDoor": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aff55133778544e381451060a5574cef/3eb70306c32e43e286fe2bb8c5b60a8f/preview/assets/ui/mysterious_door.png",
      "height": 180,
      "transparent": true,
      "width": 120
    }
  }
};
